import { render, staticRenderFns } from "./CmsMenu.vue?vue&type=template&id=374f841c&scoped=true"
import script from "./CmsMenu.vue?vue&type=script&lang=ts"
export * from "./CmsMenu.vue?vue&type=script&lang=ts"
import style0 from "./CmsMenu.vue?vue&type=style&index=0&id=374f841c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f841c",
  null
  
)

export default component.exports